exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-category-text-menu {\n  max-width: 1100px;\n  margin: auto;\n  position: relative;\n  margin-bottom: 90px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/category-text-menu/category-text-menu.scss
 ** module id = 545
 ** module chunks = 1 27 28 113
 **/